module.exports = __webpack_public_path__ + "static/media/unnamed (4).19a67461.webp";